export const SET_CONFIG='SET_CONFIG';
export const LOAD_CONFIG='LOAD_CONFIG';